import * as React from 'react'
import { Link } from 'react-router-dom'
import { StatusChip } from 'uiComponents/statusChip/statusChip'
import { SkeletonBar } from 'uiComponents/skeleton/skeleton'
import { TimeSlotGroup } from 'timeSlots/timeSlotsService'
import { TIME_SLOT_STATUS_TONE } from 'timeSlots/statusTone'
import { capacityPaths } from 'capacity/paths'
import { GroupDetail } from 'capacity/hooks/useTimeSlotGroupDetails'
import { daysLine, timesLine } from '../model/timeSlotFormat'
import { useTranslation } from 'translations'

interface TimeSlotGroupCardProps {
    accountSlug: string
    group: TimeSlotGroup
    detail?: GroupDetail
}

export function TimeSlotGroupCard({ accountSlug, group, detail }: TimeSlotGroupCardProps) {
    const { t } = useTranslation()
    const slots = Array.isArray(group.timeSlots) ? group.timeSlots : detail?.group?.timeSlots
    return (
        <div className="capacity-section-row capacity-section-group">
            <div className="capacity-section-group-main">
                <span className="capacity-section-group-name">
                    <span className="capacity-section-strong">{group.name}</span>
                    <StatusChip
                        label={t(`capacity.timeSlots.status.${group.status}`)}
                        tone={TIME_SLOT_STATUS_TONE[group.status]}
                    />
                </span>
                <span className="capacity-section-detail">
                    {slots ? (
                        timesLine(slots)
                    ) : detail?.status === 'error' ? (
                        t('capacity.formSection.timesFailed')
                    ) : (
                        <SkeletonBar width="14rem" height="0.8rem" className="capacity-section-ghost" />
                    )}
                </span>
                <span className="capacity-section-detail">{daysLine(group)}</span>
            </div>
            <Link className="capacity-section-link" to={capacityPaths.timeSlotGroup(accountSlug, group.id)}>
                {t('capacity.formSection.editTimeSlots')}
            </Link>
        </div>
    )
}
